export default __webpack_public_path__ + "static/media/SeñorEquilibristaA2.3dba98cb.png";